export const TAGS_REQUEST = '@tags/TAGS_REQUEST';
export const TAGS_SUCCESS = '@tags/TAGS_SUCCESS';
export const TAGS_FAILURE = '@tags/TAGS_FAILURE';

export const MEMBERS_BY_TAG_REQUEST = '@tags/MEMBERS_BY_TAG_REQUEST';
export const MEMBERS_BY_TAG_SUCCESS = '@tags/MEMBERS_BY_TAG_SUCCESS';
export const MEMBERS_BY_TAG_FAILURE = '@tags/MEMBERS_BY_TAG_FAILURE';
